module.exports = __webpack_public_path__ + "ci.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/css/fonts/flag-icon-css/flags/4x3/ci.svg
// module id = 489
// module chunks = 0